import { HIDE_CLASS } from './utils';

function resetValidation(form): void {
  form.querySelectorAll('.parsley-errors-list').forEach((el) => el.remove());
  form.querySelectorAll('._is-error').forEach((el) => el.classList.remove('_is-error'));
  form.querySelectorAll('.errors-list').forEach((el) => el.remove());
  form.querySelectorAll('._has-value').forEach((el) => el.classList.remove('_has-value'));
}

function toggleEditView(e, isEditing: boolean): void {
  const currentTarget = e.currentTarget as HTMLElement;
  const currentDetailsEl = currentTarget?.closest('.panel')?.querySelector('.update-details__current-details');
  const formWrapperEl = currentTarget?.closest('.panel')?.querySelector('.update-details__form');

  if (isEditing) {
    currentTarget?.classList.add(HIDE_CLASS);
  } else {
    const editEl = currentTarget?.closest('.panel')?.querySelector('.section-header__edit');
    editEl?.classList.remove(HIDE_CLASS);
  }

  currentDetailsEl?.classList.toggle(HIDE_CLASS);
  formWrapperEl?.classList.toggle(HIDE_CLASS);
}

export default function initEditButtons(): void {
  const editButtons = document.querySelectorAll('.update-details .section-header__edit');
  const cancelButtons = document.querySelectorAll('.update-details .cancel-edit');
  const searchParams = new URLSearchParams(window.location.search);
  const isEditProfile = searchParams.get('editprofile');

  editButtons.forEach((el) => {
    el.addEventListener('click', (e) => {
      toggleEditView(e, true);
    });
  });

  cancelButtons.forEach((el) => {
    const form = el.closest<HTMLFormElement>('form') as HTMLFormElement;
    el.addEventListener('click', (e) => {
      resetValidation(form);
      form.reset();
      toggleEditView(e, false);
    });
  });

  const errorMessage = document.querySelector<HTMLElement>('.form-msg-error');

  if (errorMessage) {
    errorMessage.closest('.panel')?.querySelector<HTMLElement>('.section-header__edit')?.click();
  }

  if (isEditProfile === 'true') {
    if (editButtons[0] instanceof HTMLElement) {
      editButtons[0].click();
    }
  }
}
